import { render, staticRenderFns } from "./refundDetails.vue?vue&type=template&id=017c6eed&scoped=true&"
import script from "./refundDetails.vue?vue&type=script&lang=js&"
export * from "./refundDetails.vue?vue&type=script&lang=js&"
import style0 from "./refundDetails.vue?vue&type=style&index=0&id=017c6eed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c6eed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017c6eed')) {
      api.createRecord('017c6eed', component.options)
    } else {
      api.reload('017c6eed', component.options)
    }
    module.hot.accept("./refundDetails.vue?vue&type=template&id=017c6eed&scoped=true&", function () {
      api.rerender('017c6eed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refund/refundDetails.vue"
export default component.exports